import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getAppRoutePermissions } from '@ui/guards/route-checks';
import { getGetApplicationOverviewQueryOptions, getGetApplicationSummaryQueryOptions } from 'ze-sdk';
import { z } from 'zod';
const ApplicationSearchSchema = z.object({
    contributors: z.string().optional()
}).passthrough();
export const Route = createFileRoute('/org/$organization/$project/app/$application')({
    component: Component,
    validateSearch: (search)=>ApplicationSearchSchema.parse(search),
    loader: async (param)=>{
        let { params, context } = param;
        const { application, project, organization } = params;
        await Promise.all([
            context.queryClient.ensureQueryData(getGetApplicationSummaryQueryOptions({
                organization,
                project,
                application
            })),
            context.queryClient.ensureQueryData(getGetApplicationOverviewQueryOptions({
                organization,
                project,
                application
            }))
        ]);
        // Fetch permissions for Layout navigation
        const permissions = await getAppRoutePermissions(context.queryClient, organization, project, application);
        return {
            permissions
        };
    }
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
